import { createI18n } from 'vue-i18n';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PiniaLogger from 'pinia-logger';
import messages from '@intlify/unplugin-vue-i18n/messages';
import router from '@/router';
import App from './App.vue';
import { AuthConfig } from '@repo/core/security';
import { Icon } from '@iconify/vue';
import { createAuth, createLoader, createDates } from '@repo/vue/plugins';
import { createSetup } from '@/plugins/app';
import { createTheme } from '@/plugins/theme';

import '@/assets/styles/main.scss';

const pinia = createPinia();
pinia.use(
  PiniaLogger({
    expanded: false,
    showDuration: true,
    showTime: true,
    logErrors: true,
    showPineapple: true,
    showStoreName: true,
    disabled: import.meta.env.MODE === 'production' || import.meta.env.MODE === 'ci'
  })
);

const i18n = createI18n({
  locale: 'en-ZA',
  messages
});

const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(i18n);

app.use(createDates());
app.use(createTheme());
app.use(createLoader());
app.use(createAuth(AuthConfig));

app.component('Icon', Icon);

app.use(createSetup());
